import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Card(theme: Theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          position: 'relative',
          boxShadow: theme.customShadows.card,
          borderRadius: Number(theme.shape.borderRadius) * 2,
          zIndex: 0, // Fix Safari overflow: hidden with border radius
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { variant: 'subtitle1' },
        subheaderTypographyProps: { variant: 'subtitle2', marginTop: theme.spacing(1) },
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0),
        },
        action: {
          marginTop: 'unset',
          marginRight: 'unset',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0, 3, 2),
        },
      },
    },
  };
}
